export class Pessoa {
  id: number;
  nome: string;
  email: string;
  telefone: string;

  constructor(id = 0, nome = "", email = "", telefone = "") {
    this.id = id;
    this.nome = nome;
    this.email = email;
    this.telefone = telefone;
  }
}
